<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon color="error">error</mat-icon>{{error.message}}
    </mat-panel-title>
    <mat-panel-description>
      <button mat-icon-button class="dismiss-error" color="warn" (click)="onDismiss.emit(error)">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <p *ngIf="error.error">Error data: {{error.error | json}}</p>
  <p *ngIf="error.source">Source: {{error.source}}</p>
  <a href="{{errorLink}}" id="errorLink">Report This Issue</a>

</mat-expansion-panel>
